import { useEffect, useState } from "react";
import { useAuth } from "../services/firebase.ts";
import {
  GameRecord,
  getHistoryFromFirebase,
  mergeAndSyncHistory,
  readGameHistory,
} from "../services/userHistory.ts";

export const useHistory = () => {
  const [history, setHistory] = useState<GameRecord[]>([]);
  const auth = useAuth();

  useEffect(() => {
    const getHistory = async () => {
      let localHistory = readGameHistory();
      if (auth?.user) {
        const fireBaseHistory = await getHistoryFromFirebase(auth.user);
        setHistory(
          mergeAndSyncHistory(localHistory, auth.user, fireBaseHistory),
        );
      } else {
        setHistory(localHistory);
      }
    };

    getHistory();
  }, [auth?.user]);

  return history;
};
